import React, { lazy, Suspense } from 'react';
import { createBrowserRouter, Outlet } from 'react-router-dom';
import { Spinner } from '@epo/epods-react-components/lib/Components/Spinner';
import MainLayout from '../layout/MainLayout';
import ErrorFallback from '../components/ErrorFallback';
import Paths from '../constants/path';

const Home = lazy(() => import(/* webpackChunkName: "pages/home" */ '../pages/Home'));
const History = lazy(() => import(/* webpackChunkName: "pages/home" */ '../pages/Details'));
const NotFound = lazy(() => import(/* webpackChunkName: "pages/not-found" */ '../pages/NotFound'));

const SuspenseFallback: React.FC = () => (
    <Suspense fallback={<Spinner />}>
        <Outlet />
    </Suspense>
);

const router = createBrowserRouter([
    {
        path: Paths.HOME,
        element: <MainLayout><SuspenseFallback /></MainLayout>,
        errorElement: <ErrorFallback />,
        children: [
            { path: Paths.HOME, element: <Home /> },
            { path: Paths.HISTORY, element: <History /> },
            { path: '*', element: <NotFound /> },
        ],
    },
]);

export default router;